import { createFileRoute } from "@tanstack/react-router";
import { TendersOverviewPage } from "@/pages/tenders-overview/ui/tenders-overview-page";
import { preloadTenderOverviewQueries } from "@/pages/tenders-overview/api/preload-tender-overview-queries";
import { searchParams } from "@/pages/tenders-overview/model/search-params";

export const Route = createFileRoute("/_authed/$companySlug/tenders/")({
  component: TendersOverviewPage,
  loader: ({ context }) => {
    // company is guaranteed by $companySlug beforeLoad redirect guard
    if (context.company) {
      void preloadTenderOverviewQueries(context.company.id);
    }
  },
  validateSearch: searchParams,
});
